'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _reactRouter = require('react-router');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../components');

var _capitalizeFirstLetter = require('../../helpers/capitalizeFirstLetter');var _capitalizeFirstLetter2 = _interopRequireDefault(_capitalizeFirstLetter);
var _formatCurrency = require('../../utils/formatCurrency');var _formatCurrency2 = _interopRequireDefault(_formatCurrency);
var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _checkIsForeignAddress = require('../../helpers/checkIsForeignAddress');var _checkIsForeignAddress2 = _interopRequireDefault(_checkIsForeignAddress);
var _formatTimeFromDate = require('../../helpers/formatTimeFromDate');var _formatTimeFromDate2 = _interopRequireDefault(_formatTimeFromDate);
var _getIconStatus = require('../../utils/getIconStatus');
var _makeSharingUrl = require('../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);
var _constants = require('../../constants');
var _helpers = require('./helpers');var _helpers2 = _interopRequireDefault(_helpers);
var _PropertiesTable = require('./PropertiesTable.scss');var styles = _interopRequireWildcard(_PropertiesTable);
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _parkingConverter = require('../../utils/parkingConverter');var _parkingConverter2 = _interopRequireDefault(_parkingConverter);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Helpers
var TableRow = function (_Component) {_inherits(TableRow, _Component);
  function TableRow(props) {_classCallCheck(this, TableRow);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.







    checkFilteredOption = function (el) {return _this.props.filterredColumns.indexOf(el) !== -1;};_this.

    openDetailsPopup = function () {var _this$props$property =

      _this.props.property,id = _this$props$property.id,addressObject = _this$props$property.address,propertyType = _this$props$property.property_type,_this$props$property$ = _this$props$property.additional_info,rooms = _this$props$property$.rooms,area = _this$props$property$.area,floor = _this$props$property$.floor.on_the,parkingSpots = _this$props$property$.parking,price = _this$props$property.price,optionType = _this$props$property.search_option;

      _this.props.openDetailsPopup({
        propertyId: id,
        address: addressObject,
        price: price,
        optionType: optionType,
        propertyType: propertyType,
        additionalInfo: {
          area: area,
          floor: floor,
          parkingSpots: (0, _parkingConverter2.default)(parkingSpots),
          rooms: rooms } });


      (0, _analyticsManager.trackModalOpen)('property/' + id);
    };_this.

    checkIfJumpToTopDisabled = function () {var _this$props$property2 =




      _this.props.property,moveToTop = _this$props$property2.move_to_top,isPromoted = _this$props$property2.is_promoted,isTopPromoted = _this$props$property2.is_top_promoted;

      if (isPromoted || isTopPromoted) {
        return true;
      }

      if (moveToTop) {
        return false;
      }

      return true;
    };_this.

    toggleHighlight = function () {var _this$props$property3 =

      _this.props.property,id = _this$props$property3.id,isPromoted = _this$props$property3.is_promoted,isActive = _this$props$property3.is_active,isSuspended = _this$props$property3.is_suspended,isRocketPromoted = _this$props$property3.is_rocket_promoted;
      if (isRocketPromoted) {
        _this.props.toggleRocketPromoted(_this.props.property, true);
      } else if (isActive && !isSuspended && !_this.props.disabledPromotionAction) {
        _this.props.updatePropertyHighlighting({
          ids: [id],
          promote: !isPromoted });

      }
    };_this.

    toggleAutoJumpActivity = function () {var _this$props$property4 =

      _this.props.property,id = _this$props$property4.id,isActive = _this$props$property4.is_active,isSuspended = _this$props$property4.is_suspended,autoJumpEnabled = _this$props$property4.is_autojump_enabled,isRocketPromoted = _this$props$property4.is_rocket_promoted;
      if (isRocketPromoted) {
        _this.props.toggleRocketPromoted(_this.props.property, true);
      } else if (isActive && !isSuspended && !_this.props.disabledPromotionAction) {
        _this.props.updateAutoJumpToTopActivity({
          ids: [id],
          enable: !autoJumpEnabled });

      }
    };_this.

    toggleRocketPromoted = function () {var
      property = _this.props.property;
      _this.props.toggleRocketPromoted(property);
    };_this.

    toggleMoveToTop = function () {var _this$props$property5 =


      _this.props.property,id = _this$props$property5.id,isActive = _this$props$property5.is_active,isSuspended = _this$props$property5.is_suspended,autoJumpEnabled = _this$props$property5.is_autojump_enabled,moveToTop = _this$props$property5.move_to_top,isRocketPromoted = _this$props$property5.is_rocket_promoted;

      var isMovePropertyToTop = isActive && !isSuspended &&
      !_this.props.disabledPromotionAction && !_this.checkIfJumpToTopDisabled();

      if (isRocketPromoted) {
        _this.props.toggleRocketPromoted(_this.props.property, true);
      } else if (isMovePropertyToTop) {
        _this.props.movePropertyToTop(id);
      }
    };_this.

    toggleTopPromotion = function () {var _this$props$property6 =

      _this.props.property,id = _this$props$property6.id,isActive = _this$props$property6.is_active,isSuspended = _this$props$property6.is_suspended,isTopPromoted = _this$props$property6.is_top_promoted,isRocketPromoted = _this$props$property6.is_rocket_promoted;
      if (isRocketPromoted) {
        _this.props.toggleRocketPromoted(_this.props.property, true);
      } else if (isActive && !isSuspended && !_this.props.disabledPromotionAction) {
        _this.props.updateTopPromotionActivity({
          ids: [id],
          promote: !isTopPromoted });

      }
    };_this.

    handleEdit = function (event) {
      event.stopPropagation();var _this$props$property7 =
      _this.props.property,id = _this$props$property7.id,country_name = _this$props$property7.address.en.country_name;

      _this.props.editProperty(id);
      setTimeout(function () {
        if (country_name.indexOf('Israel') !== -1) {
          _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/property/edit?id=' + id));
        } else {
          _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/foreign_property/edit?id=' + id));
        }
      });
    };_this.

    showShareTooltip = function () {var
      property = _this.props.property;var _ref =
      property || {},suspended = _ref.is_suspended,active = _ref.is_active;

      if (!suspended && active) {
        _this.setState({ isShareTooltipShown: true });
      }
    };_this.

    formatAddress = function (address) {
      var house = !!address.house_number ? ' ' + address.house_number : '';

      return '' + address.street_name + house + (house || address.street_name ? ', ' : '') + address.city_name + ', ' + address.country_name;
    };_this.

    dataTitleJumpToTop = function () {var _this$props$property8 =




      _this.props.property,isPromoted = _this$props$property8.is_promoted,isTopPromoted = _this$props$property8.is_top_promoted,moveToTop = _this$props$property8.move_to_top;

      if (isPromoted || isTopPromoted) {
        return 'alreadyHaveAnotherPromotion';
      }

      if (moveToTop) {
        return 'jumpToTopTitle';
      }

      return 'jumpToTopDisableTitle';
    };_this.

    handleLoadSinglePropertyAnalytics = function (action, propertyViews, publishDate, id) {
      var start = new Date();
      start.setDate(start.getDate() - 10);
      _this.props.loadSinglePropertyAnalytics({
        ids: [id],
        action: action,
        end: new Date(),
        start: start });

      _this.props.openChartOfViews({ publishDate: publishDate, propertyViews: propertyViews, analyticsAction: action });
    };_this.

    renderVRIcon = function () {return _this.props.property.vr_link &&
      _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.labelVR, 'icon', 'icon-vr-view') },
        _react2.default.createElement('span', { className: 'path1' }),
        _react2.default.createElement('span', { className: 'path2' }),
        _react2.default.createElement('span', { className: 'path3' }),
        _react2.default.createElement('span', { className: 'path4' }),
        _react2.default.createElement('span', { className: 'path5' }));};_this.



    renderShareButton = function () {var _this$props =
      _this.props,locale = _this$props.locale,translate = _this$props.translate,property = _this$props.property;var _ref2 =
      property || {},id = _ref2.id;

      var sharingUrl = (0, _makeSharingUrl2.default)('/home_details/' + id, locale);

      return (
        _react2.default.createElement('div', { className: styles.shareButton },
          _react2.default.createElement('div', { onClick: _this.showShareTooltip },
            _react2.default.createElement('i', { className: 'icon icon-share' })),

          _this.state.isShareTooltipShown &&
          _react2.default.createElement(_components.ShareTooltip, {
            locale: _this.props.locale,
            className: 'managePropertyRealtor',
            sharingData: { sharingUrl: sharingUrl },
            isTooltipShown: _this.state.isShareTooltipShown,
            copyLinkTitle: '' + translate('copyLink'),
            emailTitle: '' + translate('email'),
            hideTooltip: function hideTooltip() {return _this.setState({ isShareTooltipShown: false });} })));




    };_this.

    renderTopPromotionIcon = function () {var _this$props$property9 =
      _this.props.property,isTopPromoted = _this$props$property9.is_top_promoted,hasPhotos = _this$props$property9.has_photos,isActive = _this$props$property9.is_active;var
      top_promotion = _this.props.top_promotion;
      var topPromotionStatus = (0, _getIconStatus.getIconStatus)(isTopPromoted, top_promotion);

      if (topPromotionStatus === 'disabled') {
        return (
          _react2.default.createElement('i', {
              'data-title': _this.props.translate('topPromotion' + (0, _capitalizeFirstLetter2.default)(topPromotionStatus) + 'Title'),
              className: (0, _classnames2.default)(isActive && styles.iconTitle, 'icon-top-promotion-disabled') },

            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' })));


      }

      return hasPhotos ?
      _react2.default.createElement('i', {
          onClick: _this.toggleTopPromotion,
          'data-title': _this.props.translate('topPromotion' + (0, _capitalizeFirstLetter2.default)(topPromotionStatus) + 'Title'),
          className: (0, _classnames2.default)(isActive && styles.iconTitle, 'icon-top-promotion' + (0, _getIconStatus.addEnding)(topPromotionStatus)) },

        _react2.default.createElement('span', { className: 'path1' }),
        _react2.default.createElement('span', { className: 'path2' })) :


      _react2.default.createElement('i', {
          'data-title': _this.props.translate('managePage', 'requiredPromotionTopDescription'),
          className: (0, _classnames2.default)(isActive && styles.iconTitle, 'icon icon-top-promotion-disabled') },

        _react2.default.createElement('span', { className: 'path1' }),
        _react2.default.createElement('span', { className: 'path2' }));


    };_this.

    renderAutoJumpDataTitle = function () {var
      manualJumpDate = _this.props.property.manual_jump_date;

      if (!!manualJumpDate) {
        return '\n        ' +
        _this.props.translate(_this.dataTitleJumpToTop()) + '\n        ' +
        _this.props.translate('managePage', 'manualJumpDate') + ' \n        ' +
        (0, _formatTimeFromDate2.default)(manualJumpDate) + '\n      ';

      }

      return _this.props.translate(_this.dataTitleJumpToTop());
    };_this.state = { isTooltipShown: false, isShareTooltipShown: false, tooltipId: null };return _this;}TableRow.prototype.

  render = function render() {var _this2 = this,_cx,_cx2;var _props$property =

















    this.props.property,id = _props$property.id,addressObject = _props$property.address,propertyType = _props$property.property_type,_props$property$addit = _props$property.additional_info,rooms = _props$property$addit.rooms,square = _props$property$addit.area.base,floor = _props$property$addit.floor.on_the,price = _props$property.price,currency = _props$property.currency,createdAt = _props$property.created_at,isActive = _props$property.is_active,isPromoted = _props$property.is_promoted,autoJumpEnabled = _props$property.is_autojump_enabled,isTopPromoted = _props$property.is_top_promoted,isSuspended = _props$property.is_suspended,moveToTop = _props$property.move_to_top,hasPhotos = _props$property.has_photos;

    var images = hasPhotos ? _react2.default.createElement('i', { className: 'icon-images' }) : null;
    var isRocketPromoted = (0, _helpers2.default)(this.props.property);var _props =


    this.props,translate = _props.translate,_props$locale = _props.locale,locale = _props$locale === undefined ? 'en' : _props$locale,propertiesAnalytics = _props.propertiesAnalytics,jumpPromotion = _props.jumpPromotion,promotion = _props.promotion,top_promotion = _props.top_promotion,isPublishPermissionsForeign = _props.isPublishPermissionsForeign;var _state =

    this.state,isTooltipShown = _state.isTooltipShown,tooltipId = _state.tooltipId;

    var propertyAnalyticsData = propertiesAnalytics.data && propertiesAnalytics.data.find(function (item) {return item.id === id;});var _ref3 =
    propertyAnalyticsData || {},events = _ref3.events;
    var propertyViewEvent = events && events.find(function (item) {return item.action === _constants.analyticsEventAction.VIEW;});var _ref4 =
    propertyViewEvent || {},propertyViews = _ref4.count;

    var propertyAnalyticsFavouritesData = propertiesAnalytics.favoritesData &&
    propertiesAnalytics.favoritesData.find(function (item) {return item.id === id;});var _ref5 =
    propertyAnalyticsFavouritesData || {},favoritesEvents = _ref5.events;
    var propertyFavoritesEvent = favoritesEvents &&
    favoritesEvents.find(function (item) {return item.action === _constants.analyticsEventAction.FAVOURITES;});var _ref6 =
    propertyFavoritesEvent || {},propertyFavorites = _ref6.count;

    var propertyAnalyticsNumberData = propertiesAnalytics.ShowNumberData &&
    propertiesAnalytics.ShowNumberData.find(function (item) {return item.id === id;});var _ref7 =
    propertyAnalyticsNumberData || {},numberEvents = _ref7.events;
    var propertyNumberEvent = numberEvents &&
    numberEvents.find(function (item) {return item.action === _constants.analyticsEventAction.SHOW_NUMBER;});var _ref8 =
    propertyNumberEvent || {},propertyNumber = _ref8.count;

    var address = addressObject[locale] ?
    this.formatAddress(addressObject[locale]) :
    this.formatAddress(addressObject.en);

    var activity = isActive ? 'active' : 'inactive';
    var status = isSuspended ?
    _react2.default.createElement('div', { className: styles.suspended },
      translate('managePage', 'suspended'),
      _react2.default.createElement(_components.BottomTooltip, {
        className: 'manageTableTooltip',
        msg:
        _react2.default.createElement('span', null,
          translate('managePage', 'suspendedTooltip'),
          _react2.default.createElement('a', {
              href: 'mailto:' + _constants.supportEmail,
              className: 'link',
              onClick: function onClick(evt) {return evt.stopPropagation();} }, ' ', _constants.supportEmail)) })) :






    _react2.default.createElement('i', { className: 'icon icon-' + activity }, _react2.default.createElement('i', { className: 'path1' }), _react2.default.createElement('i', { className: 'path2' }));
    var propType = translate('propertyTypes', propertyType);
    var publishDate = (0, _moment2.default)(createdAt).format('DD/MM/YYYY');
    var houseNumberIsHidden = addressObject && addressObject.hide_house_number;
    var autoJumpStatus = (0, _getIconStatus.getIconStatus)(autoJumpEnabled, jumpPromotion);
    var promotionStatus = (0, _getIconStatus.getIconStatus)(isPromoted, promotion);
    var isForeign = (0, _checkIsForeignAddress2.default)(addressObject);

    var handleExposures = function handleExposures() {return _this2.handleLoadSinglePropertyAnalytics(
      _constants.analyticsEventAction.VIEW, propertyViews, publishDate, id);};

    var handlePhone = function handlePhone() {return _this2.handleLoadSinglePropertyAnalytics(
      _constants.analyticsEventAction.SHOW_NUMBER, propertyNumber, publishDate, id);};

    var handleFavourites = function handleFavourites() {return _this2.handleLoadSinglePropertyAnalytics(
      _constants.analyticsEventAction.FAVOURITES, propertyFavorites, publishDate, id);};


    return (
      _react2.default.createElement('tr', {
          key: id,
          className: (0, _classnames2.default)((_cx = {}, _cx[
          styles.inactive] = !isActive || isSuspended, _cx[
          styles.selected] = this.props.isSelected, _cx[
          styles.backgroundRocket] = isRocketPromoted, _cx)) },


        _react2.default.createElement('td', null,
          _react2.default.createElement(_components.OMCheckbox, {
            id: id,
            label: '',
            field: {
              value: false,
              checked: this.props.isSelected,
              onChange: function onChange() {return _this2.props.handleCheck({
                  id: id,
                  isActive: isActive,
                  property: _this2.props.property,
                  isForeignProperty: (0, _checkIsForeignAddress2.default)(addressObject) });} } })),




        _react2.default.createElement('td', { className: styles.centered }, this.props.numberInOrder),
        _react2.default.createElement('td', null, translate('title', this.props.property.search_option)),
        this.checkFilteredOption('status') && _react2.default.createElement('td', { className: styles.statusCell }, status),
        _react2.default.createElement('td', null,
          _react2.default.createElement('div', { className: styles.addressCell },
            _react2.default.createElement('div', { className: styles.exclamationTooltip },
              houseNumberIsHidden &&
              _react2.default.createElement(_components.BottomTooltip, {
                icon: _react2.default.createElement('span', { className: styles.exclamationIcon }, _react2.default.createElement('i', { className: 'icon icon-exclamation' })),
                warnTooltip: true,
                className: 'exclamationIconTooltip',
                msg: _react2.default.createElement('span', null, translate('publishProperty', 'houseNumberIsHidden')) })),


            _react2.default.createElement('div', { className: styles.address, onClick: this.openDetailsPopup }, address)),

          _react2.default.createElement('div', { className: styles.publishDate }, publishDate)),

        _react2.default.createElement('td', null, propType),
        _react2.default.createElement('td', { className: styles.nowrap }, '\u202A' + (0, _formatCurrency2.default)(currency) + ' ' + (0, _beautifyNumber2.default)(price)),
        this.checkFilteredOption('rooms') && _react2.default.createElement('td', { className: styles.narrowColumns }, rooms),
        this.checkFilteredOption('floor') && _react2.default.createElement('td', { className: styles.narrowColumns }, floor),
        this.checkFilteredOption('images') && _react2.default.createElement('td', null, images, '\xA0\xA0', this.renderVRIcon()),
        this.checkFilteredOption('exposures') && _react2.default.createElement('td',
          propertyViews && { onClick: handleExposures },

          _react2.default.createElement('span', { className: propertyViews ? styles.chartLink : '' }, propertyViews || '-')),

        this.checkFilteredOption('phoneClicksCount') && _react2.default.createElement('td',
          propertyNumber && !isForeign && { onClick: handlePhone },

          _react2.default.createElement('span', { className: propertyNumber ? styles.chartLink : '' }, !isForeign && propertyNumber || '-')),

        this.checkFilteredOption('favouritesCount') && _react2.default.createElement('td',
          propertyFavorites && !isForeign && { onClick: handleFavourites },

          _react2.default.createElement('span', { className: propertyFavorites ? styles.chartLink : '' }, !isForeign && propertyFavorites || '-')),

        this.checkFilteredOption('share') && _react2.default.createElement('td', null, this.renderShareButton()),
        this.checkFilteredOption('activePromotion') && _react2.default.createElement('td', null,
          isForeign ? '-' :
          _react2.default.createElement('div', { className: styles.promotionCell },
            this.renderTopPromotionIcon(),
            _react2.default.createElement('i', {
                onClick: this.toggleHighlight,
                'data-title': this.props.translate('highlight' + (0, _capitalizeFirstLetter2.default)(promotionStatus) + 'Title'),
                className: (0, _classnames2.default)('icon-promoted' +
                (0, _getIconStatus.addEnding)(promotionStatus),
                promotionStatus === 'disabled' && isActive && styles.iconTitle) },


              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' })),










            autoJumpEnabled ? null :
            _react2.default.createElement('i', {
                onClick: this.toggleMoveToTop,
                'data-title': this.renderAutoJumpDataTitle(),
                className: (0, _classnames2.default)(
                isActive && styles.iconTitle, 'icon icon-jump-to-top' + (
                this.checkIfJumpToTopDisabled() ? '-disabled' : '')) },


              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' })),



            _react2.default.createElement('i', {
              onClick: this.toggleRocketPromoted,
              'data-title': this.props.translate('rocketPromotedTitle'),
              className: (0, _classnames2.default)(
              isActive && styles.iconTitle, 'icon icon-rocket' + (
              isRocketPromoted ? '-active' : '')) }))),






        _react2.default.createElement('td', null,
          _react2.default.createElement('div', { className: styles.editCell, onClick: this.handleEdit },
            _react2.default.createElement('i', { className: 'icon icon-edit' }),
            _react2.default.createElement('span', null, this.props.translate('edit')))),


        _react2.default.createElement('td', { className: (0, _classnames2.default)(styles.actionCell, (_cx2 = {}, _cx2[styles.tooltipIsOpen] = this.state.isTooltipShown, _cx2)) },
          _react2.default.createElement('span', {
              className: styles.tooltipHandler,
              onClick: function onClick() {return _this2.setState({
                  isTooltipShown: true,
                  tooltipId: id });} },


            _react2.default.createElement('i', { className: 'icon icon-more_actions' })),

          isTooltipShown && tooltipId === id &&
          _react2.default.createElement(_components.ActionsTooltip, {
            property: Object.assign({}, this.props.property, { property_type: propType }),
            editProperty: this.props.editProperty,
            translate: translate('managePage'),
            locale: locale,
            isTooltipShown: isTooltipShown,
            hideTooltip: function hideTooltip() {return _this2.setState({ isTooltipShown: false, tooltipId: null });},
            openDetailsPopup: this.openDetailsPopup,
            updatePropertyActivity: this.props.updatePropertyActivity,
            openContactUsModal: this.props.openContactUsModal,
            rootTranslate: translate,
            updateAutoJumpToTopActivity: this.props.updateAutoJumpToTopActivity,
            toggleHighlight: this.toggleHighlight,
            toggleAutoJumpActivity: this.toggleAutoJumpActivity,
            toggleMoveToTop: this.toggleMoveToTop,
            jumpPromotion: this.props.jumpPromotion,
            promotion: this.props.promotion,
            isPublishPermissionsForeign: this.props.isPublishPermissionsForeign }))));





  };return TableRow;}(_react.Component);exports.default = TableRow;



TableRow.propTypes = {
  property: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string.isRequired,
  editProperty: _propTypes2.default.func.isRequired,
  openDetailsPopup: _propTypes2.default.func.isRequired,
  updatePropertyActivity: _propTypes2.default.func.isRequired,
  updatePropertyHighlighting: _propTypes2.default.func.isRequired,
  openContactUsModal: _propTypes2.default.func.isRequired,
  promotedTitle: _propTypes2.default.string, //
  propertiesAnalytics: _propTypes2.default.array,
  movePropertyToTop: _propTypes2.default.func,
  openChartOfViews: _propTypes2.default.func,
  updateAutoJumpToTopActivity: _propTypes2.default.func,
  updateTopPromotionActivity: _propTypes2.default.func,
  loadSinglePropertyAnalytics: _propTypes2.default.func,
  handleCheck: _propTypes2.default.func,
  jumpPromotion: _propTypes2.default.object,
  promotion: _propTypes2.default.object,
  top_promotion: _propTypes2.default.object,
  isSelected: _propTypes2.default.bool.isRequired,
  numberInOrder: _propTypes2.default.number.isRequired,
  filterredColumns: _propTypes2.default.array,
  disabledPromotionAction: _propTypes2.default.bool,
  isPublishPermissionsForeign: _propTypes2.default.bool,
  toggleRocketPromoted: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PropertiesTable/TableRow.js
// module id = 3010
// module chunks = 0